import { Icons } from '@/assets';
import React, { forwardRef, useState } from 'react';
import { ReactSVG } from 'react-svg';

const Input = forwardRef(
  (
    {
      className,
      min,
      max,
      type,
      error,
      label,
      id,
      adornment,
      required,
      maxLength,
      backgroundColor,
      height,
      variant,
      ...props
    },
    ref
  ) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
      setShowPassword((pre) => !pre);
    };

    const passwordType = () => {
      if (type === 'password') return showPassword ? 'text' : 'password';
      return type;
    };

    return (
      <div className="flex flex-col items-start  ">
        {!!label && (
          <label
            htmlFor={id}
            className="font-averta mb-2 text-sm font-bold text-primary-text text-start flex items-center gap-1">
            {label}
            {required && (
              <>
                <span className="text-error pl-2">*</span>
                <span className="text-xs font-normal text-gray-600">
                  Required
                </span>
              </>
            )}
          </label>
        )}
        <div className="relative w-full flex flex-col items-start">
          {variant === 'textarea' ? (
            <textarea
              id={id}
              className={`${
                error ? 'border-error bg-error-light' : 'border-input'
              } ${
                adornment ? 'pl-6' : ''
              } font-averta flex p-0 py-2 m-0 box-border text-primary-text outline-none appearance-none bg-transparent  w-full pb rounded border border-solid bg-background px-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-border-secondary focus-visible:outline-none focus-visible:border-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50  hover:shadow-button-hover hover:border-black focus:border-primary-text transition-colors duration-200  ${className}`}
              style={{ background: backgroundColor, height }}
              ref={ref}
              min={min}
              max={max}
              maxLength={maxLength}
              rows={4}
              {...props}
            />
          ) : (
            <input
              id={id}
              type={passwordType()}
              className={`${
                error ? 'border-error bg-error-light' : 'border-input'
              } ${
                adornment ? 'pl-6' : ''
              } flex p-0 m-0 box-border text-primary-text outline-none appearance-none bg-transparent h-12 w-full pb rounded border border-solid bg-background px-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-border-secondary focus-visible:outline-none focus-visible:border-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50  hover:shadow-button-hover hover:border-black focus:border-primary-text transition-colors duration-200  ${className}`}
              style={{ background: backgroundColor, height }}
              ref={ref}
              min={min}
              max={max}
              maxLength={maxLength}
              {...props}
            />
          )}
          {adornment ? (
            <span
              className="absolute text-sm top-1/2 left-4   "
              style={{
                transform: 'translateY(-50%)',
              }}>
              {adornment}
            </span>
          ) : (
            type === 'password' && (
              <div
                className="absolute top-1/2 right-4 cursor-pointer"
                style={{
                  transform: 'translateY(-50%)',
                }}>
                <ReactSVG
                  src={showPassword ? Icons.eye : Icons.eyeClose}
                  onClick={handleShowPassword}
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', '20');
                    svg.setAttribute('height', '20');
                  }}
                />
              </div>
            )
          )}
        </div>
        {!!error && <span className="text-xs text-error mt-1">{error}</span>}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
